<div class="card rounded-0 text-dark">
  <div class="card-body p-3">
    <h6>{{ "invoice#" + invoice.id +"   "}}<span [class]="invoice.invoice_class">{{ invoice.payment_status }}</span></h6>
    <span class="float-right"><a type="button" href="{{invoice.site_invoice_url}}" class="btn btn-outline-primary btn-sm float-right book-button" target="_blank">View</a></span>
    <span>{{invoice.venue_name}}</span><br>
    <span>Created at: {{ invoice.created_at}}</span><br>
    <span>Updated at: {{ invoice.updated_at}}</span><br>
    <br>
  </div>
</div>